import { render, staticRenderFns } from "./NuevoPerfil.vue?vue&type=template&id=8a31723a&scoped=true"
import script from "./NuevoPerfil.vue?vue&type=script&lang=js"
export * from "./NuevoPerfil.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NuevoPerfil.vue?vue&type=style&index=1&id=8a31723a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a31723a",
  null
  
)

export default component.exports